const EnumOrderStates = {
    Draft: 1,
    Open: 2,
    Processing: 3,
    Pending : 4,
    Complete : 5,
    Placed : 10
};

export default EnumOrderStates;